




















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class vscSelect extends Vue {
    @Prop() private value!: string;
    @Prop() label!: string;
    @Prop() options!: any;
    @Prop() link!: any;
    @Prop() linkTitle!: any;
    @Prop({ default: true }) margin!: boolean;

    get inputValue() {
        return this.value;
    }

    set inputValue(input) {
        this.$emit("input", input);
    }

    get selectClasses() {
        if (this.label) return "col-lg-8";
        return "col-lg-12";
    }

    get rowClasses() {
        return `${this.margin ? "" : "mb-0"}`;
    }
}
